export const NAME = 'FlightTrackerSearch';



// WEBPACK FOOTER //
// ./modules/FlightTracker/redux/Search/constants.js